module.exports = __webpack_public_path__ + "static/img/srly_img_kuang@2x.97613a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/birthday/srly_img_kuang@2x.png
// module id = 16sF
// module chunks = 1